import { createAsyncThunk } from '@reduxjs/toolkit';

import { Instances } from '../Instances/Instances';
import { networkCall } from '../../utils/network-call';

import type { InstanceType} from '../Instances/Instances';

interface RequestObjectParams {
  instanceType: InstanceType;
  baseUrl?: string;
  includeId?: boolean;
  header?: boolean;
  data?: any;
  instanceId?: any;
  config?: any;
  fullResponse?: boolean;
  customHeaders?: any;
  dynamicUrlData?: string;
  replaceableUrlData?: Record<string, string>;
  callback?: (data: any, success: boolean) => void;
}

// Async thunk for updating single object data
export const updateObject = createAsyncThunk(
  'instance/updateObject',
  async (
    {
      instanceType,
      baseUrl = '',
      includeId = true,
      header = true,
      data,
      instanceId,
      config,
      fullResponse,
      customHeaders,
      dynamicUrlData = '',
      replaceableUrlData = {},
      callback
    }: RequestObjectParams,
    { rejectWithValue }
  ) => {
    try {
      const responseData = await networkCall(
        'PUT',
        Instances[instanceType].endpoint,
        baseUrl,
        includeId,
        header,
        data,
        instanceId,
        config,
        fullResponse,
        customHeaders,
        dynamicUrlData,
        replaceableUrlData,
        callback,
      );
      return { instanceType, data: responseData };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  }
); 

// Async thunk for creating new object data
export const createObject = createAsyncThunk(
  'instance/createObject',
  async (
    {
      instanceType,
      baseUrl = '',
      includeId = true,
      header = true,
      data,
      instanceId,
      config,
      fullResponse,
      customHeaders,
      dynamicUrlData = '',
      replaceableUrlData = {},
      callback
    }: RequestObjectParams,
    { rejectWithValue }
  ) => {
    try {
      const responseData = await networkCall(
        'POST',
        Instances[instanceType].endpoint,
        baseUrl,
        includeId,
        header,
        data,
        instanceId,
        config,
        fullResponse,
        customHeaders,
        dynamicUrlData,
        replaceableUrlData,
        callback,
      );
      return { instanceType, data: responseData };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  }
); 

export const deleteObject = createAsyncThunk(
  'instance/deleteObject',
  async (
    {
      instanceType,
      baseUrl = '',
      includeId = true,
      header = true,
      data,
      instanceId,
      config,
      fullResponse,
      customHeaders,
      dynamicUrlData = '',
      replaceableUrlData = {},
      callback
    }: RequestObjectParams,
    { rejectWithValue }
  ) => {
    try {
      const responseData = await networkCall(
        'DELETE',
        Instances[instanceType].endpoint,
        baseUrl,
        includeId,
        header,
        data,
        instanceId,
        config,
        fullResponse,
        customHeaders,
        dynamicUrlData,
        replaceableUrlData,
        callback,
      );
      return { instanceType, data: responseData };
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'An error occurred');
    }
  }
); 